import React from "react";
import {
  makeStyles,
  Box,
  Container,
  Grid,
  Typography,
  Button,
  IconButton,
} from "@material-ui/core";
import { AnimationOnScroll } from "react-animation-on-scroll";
import Chart from "src/component/Chart";
import { Link } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
  technologyBox: {
    position: "relative",
    zIndex: "9",
    padding: "50px 0 90px",
    overflow: "hidden",
    [theme.breakpoints.down("xs")]: {
      padding: "50px 0",
    },
    "& .grayText": {
      color: theme.palette.text.secondary,
    },

    "& h2": {
      lineHeight: "60px",
    },
    "& .rigntImageBox": {
      position: "absolute",
      right: "3px",
      maxWidth: "550px",
      top: "0",
      zIndex: "-1",
      [theme.breakpoints.down("md")]: {
        maxWidth: "400px",
        top: "17%",
      },
    },
  },
}));

function Technology() {
  const classes = useStyles();
  return (
    <>
      <Box className={classes.technologyBox}>
        <Box className="cirlceBoxorange"></Box>
        <AnimationOnScroll animateIn="animate__fadeInRight">
          <img
            src="images/technology_img.png"
            alt="image"
            className="rigntImageBox"
          />
        </AnimationOnScroll>
        <Container maxWidth="lg">
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} lg={7} sm={7} md={7}>
              <AnimationOnScroll animateIn="animate__fadeInLeft">
                <Typography variant="h2" color="primary">
                  Empowering businesses with the next generation of blockchain
                  technology
                </Typography>
              </AnimationOnScroll>
              <AnimationOnScroll animateIn="animate__fadeInUp">
                <Box mt={2}>
                  <Typography variant="body2" className="grayText">
                    Fieres's blockchain technology is a game-changing platform
                    for financial transactions, offering users a secure and
                    transparent solution. With the ability to create and deploy
                    smart contracts, the platform delivers an unprecedented
                    level of automation that traditional systems cannot match.
                  </Typography>
                </Box>
                <Box mt={2}>
                  <Typography variant="body2" className="grayText">
                    By utilizing Fieres's blockchain technology, users can
                    conduct transactions without intermediaries, benefiting from
                    enhanced security and efficiency. The technology's inherent
                    immutability and trustworthiness also allow for easier
                    tracking and auditing of financial data, resulting in lower
                    costs and improved transparency. With Fieres's blockchain
                    technology, you can confidently build a financial system
                    that is efficient, secure, and entirely self-sufficient.
                  </Typography>
                </Box>
              </AnimationOnScroll>
              {/* <Box mt={2}>
                <Button
                  variant="contained"
                  color="primary"
                  // component={Link}
                  // // to="/explore"
                  target="_blank"
                  href="https://fieroscan.com/"
                >
                  Explore Dapps
                </Button>
              </Box> */}
            </Grid>
            {/* <Grid item xs={12} lg={5} sm={5} md={5}>
              <img src="images/technology_img.png" alt="image" />
            </Grid> */}
          </Grid>
        </Container>
      </Box>
    </>
  );
}

export default Technology;
